import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    deleteBureauRequest: ['response'],
    deleteBureauSuccess: ['response'],
    deleteBureauFailure: ['error'],
})

export const deleteBureauTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const deleteBureauRequest = state => state.merge({ success: null })

const deleteBureauSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const deleteBureauFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}
export const reducer = createReducer(INITIAL_STATE, {
    [Types.DELETE_BUREAU_REQUEST]: deleteBureauRequest,
    [Types.DELETE_BUREAU_SUCCESS]: deleteBureauSuccess,
    [Types.DELETE_BUREAU_FAILURE]: deleteBureauFailure,
})
